import { ArchiveX } from 'lucide-react';

export default function EmptyState({
  title = 'Sin datos disponibles',
  description = 'Todavía no hay registros para mostrar.',
  icon: Icon = ArchiveX,
  action,
}) {
  return (
    <div className="flex flex-col items-center justify-center rounded-2xl border border-[rgba(var(--border),0.6)] bg-[rgba(var(--panel),0.7)] px-6 py-12 text-center shadow-[0_18px_36px_rgba(var(--shadow),0.12)]">
      <div className="flex h-14 w-14 items-center justify-center rounded-2xl bg-[rgba(var(--panel),0.6)] text-[rgb(var(--brand))] shadow-[0_10px_30px_rgba(var(--shadow),0.12)]">
        <Icon className="h-7 w-7" aria-hidden="true" />
      </div>
      <h3 className="mt-6 text-lg font-semibold tracking-tight text-[rgb(var(--fg))]">{title}</h3>
      <p className="mt-2 max-w-md text-sm text-[rgba(var(--muted),0.9)]">{description}</p>
      {action ? <div className="mt-6">{action}</div> : null}
    </div>
  );
}
